/* =========================================================================
   CIMENTO SKATE — carrinho (carrega em todas as páginas, junto da gaveta)
   <tw-delivery>  data estimada de entrega (hoje + 8 a 15 dias úteis, sem fim de semana e feriado nacional; os números
                  vêm do Liquid em data-min/data-max). Produto, gaveta e /cart: data-format="janela" ("13 a 22/out"),
                  uma por região (Sul, Sudeste e Centro-Oeste · Norte e Nordeste). Sem JS: "8 a 15 dias úteis".
   <tw-gift>      "É presente?": grava o atributo "Presente" no carrinho (/cart/update.js); vai junto pra Yampi.
   [data-tw-add]  "+ Adicionar" e pílulas de tamanho das sugestões: adiciona sem sair da gaveta (ou de /cart) e
                  redesenha o carrinho.
   Sem dependências. Os valores em R$ chegam prontos do Liquid (snippets/tw-cart-kit.liquid).
   ========================================================================= */
(function () {
  /* ---------- Data estimada de entrega ----------
     Janela = hoje + data-min a data-max dias úteis (8 a 15: prazo TOTAL, já com os dias pra sair), contando a
     partir de amanhã e pulando sábado, domingo e feriado nacional (fixos + Carnaval, Sexta-feira Santa e Corpus
     Christi, calculados pela Páscoa de cada ano). A data final é a mesma regra do "no total, até 15 dias úteis". */
  const DIAS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
  const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  const FIXOS = ['01-01', '04-21', '05-01', '09-07', '10-12', '11-02', '11-15', '11-20', '12-25'];
  const cacheAno = {};

  const pad = (n) => (n < 10 ? '0' : '') + n;
  const chave = (d) => pad(d.getMonth() + 1) + '-' + pad(d.getDate());

  // Páscoa (algoritmo de Meeus/Jones/Butcher) → Carnaval (seg e ter), Sexta-feira Santa e Corpus Christi
  function moveis(ano) {
    if (cacheAno[ano]) return cacheAno[ano];
    const a = ano % 19, b = Math.floor(ano / 100), c = ano % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mes = Math.floor((h + l - 7 * m + 114) / 31), dia = ((h + l - 7 * m + 114) % 31) + 1;
    const pascoa = new Date(ano, mes - 1, dia);
    const off = (n) => chave(new Date(ano, pascoa.getMonth(), pascoa.getDate() + n));
    cacheAno[ano] = [off(-48), off(-47), off(-2), off(60)];
    return cacheAno[ano];
  }

  function diaUtil(d) {
    const w = d.getDay();
    if (w === 0 || w === 6) return false;
    const k = chave(d);
    return FIXOS.indexOf(k) === -1 && moveis(d.getFullYear()).indexOf(k) === -1;
  }

  function somaDiasUteis(inicio, n) {
    const d = new Date(inicio.getFullYear(), inicio.getMonth(), inicio.getDate());
    let feitos = 0;
    while (feitos < n) {
      d.setDate(d.getDate() + 1);
      if (diaUtil(d)) feitos++;
    }
    return d;
  }

  const fmtCurto = (d) => pad(d.getDate()) + '/' + MESES[d.getMonth()];
  const fmt = (d) => DIAS[d.getDay()] + ', ' + fmtCurto(d);
  // Formato único do produto e do carrinho (E8): "13 a 22/out"; virando o mês, "20/out a 4/nov". Sem dia da semana.
  const fmtJanela = (de, ate) =>
    de.getMonth() === ate.getMonth() && de.getFullYear() === ate.getFullYear()
      ? de.getDate() + ' a ' + ate.getDate() + '/' + MESES[ate.getMonth()]
      : de.getDate() + '/' + MESES[de.getMonth()] + ' a ' + ate.getDate() + '/' + MESES[ate.getMonth()];

  if (!customElements.get('tw-delivery')) {
    customElements.define(
      'tw-delivery',
      class TwDelivery extends HTMLElement {
        connectedCallback() {
          const min = parseInt(this.dataset.min, 10);
          const max = parseInt(this.dataset.max, 10);
          if (!(min > 0) || !(max >= min)) return;
          const hoje = new Date();
          const de = somaDiasUteis(hoje, min);
          const ate = somaDiasUteis(hoje, max);
          // data-format="janela" (produto e carrinho, com a região escrita antes): "13 a 22/out"
          // data-format="curto": "Chega de 07/out a 22/out" · sem formato: "Chega entre sex, 09/out e qua, 21/out"
          const f = this.dataset.format;
          this.textContent =
            f === 'janela'
              ? fmtJanela(de, ate)
              : f === 'curto'
              ? 'Chega de ' + fmtCurto(de) + ' a ' + fmtCurto(ate)
              : 'Chega entre ' + fmt(de) + ' e ' + fmt(ate);
        }
      }
    );
  }

  const postJSON = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json().then((json) => (r.ok ? json : Promise.reject(json))));

  const routeUrl = (key, fallback) => (window.routes && window.routes[key]) || fallback;

  /* ---------- "É presente?" ---------- */
  if (!customElements.get('tw-gift')) {
    customElements.define(
      'tw-gift',
      class TwGift extends HTMLElement {
        connectedCallback() {
          if (this.twReady) return;
          this.twReady = true;
          this.addEventListener('change', (e) => {
            // a gaveta e /cart escutam "change" pra atualizar quantidade: o checkbox não é quantidade
            e.stopPropagation();
            const input = e.target;
            const on = input.checked;
            this.setAttribute('aria-busy', 'true');
            postJSON(routeUrl('cart_update_url', '/cart/update') + '.js', { attributes: { Presente: on ? 'Sim' : '' } })
              .catch(() => {
                input.checked = !on;
              })
              .finally(() => this.removeAttribute('aria-busy'));
          });
        }
      }
    );
  }

  /* ---------- "+ Adicionar" das sugestões ---------- */
  function sectionHTML(html, selector) {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-tw-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const drawer = btn.closest('cart-drawer');
    const page = drawer ? null : document.querySelector('cart-items');
    // Seções que voltam já desenhadas na resposta do /cart/add (mesmas que o tema usa)
    const sections = drawer
      ? drawer.getSectionsToRender().map((s) => ({ id: s.id, section: s.id, selector: s.selector }))
      : page
      ? page.getSectionsToRender()
      : [];

    // Aviso de erro da faixa (snippets/tw-cart-kit.liquid, part 'upsell'): some a cada nova tentativa
    const note = btn.closest('.tw-upsell') && btn.closest('.tw-upsell').querySelector('.tw-upsell__err');
    if (note) note.hidden = true;

    // Pílula de tamanho (E2): o texto fica ("G"); a tocada preenche e as irmãs travam até a resposta
    const group = btn.closest('.tw-upsell__sizes');
    const label = btn.textContent;
    const locked = group ? Array.from(group.querySelectorAll('[data-tw-add]:not([disabled])')) : [btn];
    locked.forEach((b) => (b.disabled = true));
    btn.setAttribute('aria-busy', 'true');
    if (group) {
      group.setAttribute('aria-busy', 'true');
      btn.classList.add('is-busy');
    } else {
      btn.textContent = 'Adicionando…';
    }

    postJSON(routeUrl('cart_add_url', '/cart/add') + '.js', {
      items: [{ id: Number(btn.dataset.twAdd), quantity: 1 }],
      sections: sections.map((s) => s.section),
      sections_url: window.location.pathname,
    })
      .then((state) => {
        if (drawer) {
          drawer.renderContents(state);
          // A gaveta foi redesenhada (a pílula tocada não existe mais): o foco fica na gaveta, na régua do kit, que
          // já diz a faixa nova ("Leve 2: 5% OFF já no total..."). Sem isso ele caía no <body>, atrás da gaveta.
          const msg = document.querySelector('#CartDrawer .tw-kitbar__msg') || document.querySelector('#CartDrawer .drawer__inner');
          if (msg && typeof trapFocus === 'function') trapFocus(document.getElementById('CartDrawer'), msg);
          return;
        }
        if (!page) {
          window.location.reload();
          return;
        }
        sections.forEach((s) => {
          const host = document.getElementById(s.id);
          const html = state.sections && state.sections[s.section];
          if (!host || !html) return;
          const target = host.querySelector(s.selector) || host;
          const inner = sectionHTML(html, s.selector);
          if (inner !== null) target.innerHTML = inner;
        });
      })
      .catch((err) => {
        // O botão volta ao normal na hora; o aviso fica embaixo da faixa. 422 = estoque/quantidade, que a Shopify
        // já manda em português; o resto (429 de muitas tentativas, 5xx, resposta sem JSON) usa o texto da casa,
        // o mesmo do botão de compra (assets/product-form.js).
        locked.forEach((b) => (b.disabled = false));
        btn.removeAttribute('aria-busy');
        if (group) {
          group.removeAttribute('aria-busy');
          btn.classList.remove('is-busy');
        } else {
          btn.textContent = label;
        }
        if (!note) return;
        note.textContent =
          err && Number(err.status) === 422 && err.description
            ? err.description
            : 'Não deu pra adicionar agora. Tenta de novo em alguns segundos.';
        note.hidden = false;
      });
  });
})();
